import { DayOfWeek, getWeekStartByLocale } from 'weekstart';
import { MemberSettingsFirstDayOfWeek } from '../../gql/graphql';

type BrowserLocaleInfo = {
	language: string;
	timezone: string;
	dateFormat: string;
	currency: string;
	firstDayOfWeek: MemberSettingsFirstDayOfWeek;
};

const getFirstDayOfWeek = (numberDay: DayOfWeek): MemberSettingsFirstDayOfWeek => {
	switch (numberDay) {
		case 0:
			return 'sunday';
		case 1:
			return 'monday';
		case 6:
			return 'saturday';
		default:
			return 'monday';
	}
};

const getBrowserLocaleInfo = async (): Promise<BrowserLocaleInfo> => {
	const language = navigator.language;
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const date = new Date();
	const dateFormat = date.toLocaleDateString(language);
	const firstDayOfWeek = getFirstDayOfWeek(getWeekStartByLocale(language));

	const result = { language, timezone, dateFormat, currency: '', firstDayOfWeek };

	try {
		const response = await fetch('https://ipapi.co/json/');
		const data = await response.json();
		result.currency = data.currency;
	} catch (error) {
		console.error('[ERROR]:', error);
	} finally {
		return result;
	}
};

export { getBrowserLocaleInfo, type BrowserLocaleInfo };
